import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d75a7d4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top-content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-item" }, /*#__PURE__*/_toDisplayString("Requesting the calculation and creation of payments to VCFS of customer and dealer collections untill the cutoff date"), -1))
const _hoisted_3 = ["onSubmit"]
const _hoisted_4 = { class: "date-picker vcfs-date-selector" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-col-centered" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "submit-btn",
    type: "submit"
  }, " CREATE PAYMENT ")
], -1))

import { ref, computed } from "vue";
import Popup from "./Popup.vue";
import DatePicker from "./common/DatePicker.vue";
import DateIgnoreTime from "@/types/DateIgnoreTime";
import useNotifierWithErrFormatter from "@/services/composables/NotifierWithErrFormatter";
import useSpinnerPopup from "@/services/composables/SpinnerPopup";
import { authService } from "@/auth/authSingleton";
import { vcfsPaymentsService } from "@/services/network";
import { IVcfsPaymentRequest } from "@/Interfaces/Payments/IVcfsPaymentRequest";


export default /*#__PURE__*/_defineComponent({
  __name: 'VcfsCreatePaymentsPopUp',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;
const PopUpOpen = computed<boolean>({
    get() {
        return props.modelValue ?? false; 
    },
    set(val: boolean) {
        emits('update:modelValue', val);
    }
});

const textInputOptions = { format: "yyyy-MM-dd" };
const maxDay = new Date().addDays(7);
const selectedDate = ref<Date>();
const working = ref(false);

function closeChild() {
    PopUpOpen.value = false;
}
function FormatDatePicker(date: Date){
    return new DateIgnoreTime(date).toString();
}
async function CreatePayment() {
    if(working.value == true) return;
    const closeSpinner = useSpinnerPopup().show();
    try{
        working.value = true
        const user = authService.getEmailAddress()
        const postRequest: IVcfsPaymentRequest = 
        {
            user: user, 
            date: new DateIgnoreTime(selectedDate.value)
        }
        const response = await vcfsPaymentsService.post(postRequest)
        if(response.status == 204){
            useNotifierWithErrFormatter().notify({msg: "There is no data within the selected cutoff date that can be consolidated into a payment item." });
        }

    }catch(error){
        useNotifierWithErrFormatter().error({errorType:"VCFS payment creation", error})
    }finally{
        closeSpinner();
        working.value = false
        closeChild()
        emits("confirm");
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Popup, {
    modelValue: !!PopUpOpen.value,
    "onUpdate:modelValue": closeChild,
    title: "VCFS Payment Creation",
    hasClose: ""
  }, {
    contents: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("form", {
          class: "top-content",
          onSubmit: _withModifiers(CreatePayment, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(DatePicker, {
              modelValue: selectedDate.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedDate).value = $event)),
              placeholder: "Select cutoff date...",
              "text-input-options": textInputOptions,
              "max-date": _unref(maxDay),
              "enable-time-picker": false,
              format: FormatDatePicker,
              teleport: true,
              "text-input": "",
              required: ""
            }, null, 8, ["modelValue", "max-date"])
          ]),
          _hoisted_5
        ], 40, _hoisted_3)
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})